import { useEffect, useState } from 'react';
import { entityOp } from 'store/ducks/DataEntry/Entities';

export const useHierarchicalTreePage = <T>(
  apiFn: (entityId: number, date: string) => Promise<any>,
  extractFn: (res: any) => T[],
  entityId: number | null,
  date: string,
) => {
  const [data, setData] = useState<T[]>([]);
  const [entityOptions, setEntityOptions] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    const fetchEntity = async () => {
      const res = await entityOp.fetchEntityNames();

      setEntityOptions(
        (res?.data || []).map((e: any) => ({
          value: e.id,
          label: e.name_of_entity,
        })),
      );
    };

    fetchEntity();
  }, []);

  useEffect(() => {
    if (!entityId) return;

    let active = true;

    const fetchData = async () => {
      try {
        const res = await apiFn(entityId, date);
        if (!active) return;

        setData(extractFn(res));
      } catch (err) {
        console.error(err);
        setData([]);
      }
    };

    fetchData();

    return () => {
      active = false;
    };
  }, [entityId, date]);

  return {
    data,
    entityOptions,
  };
};
